import React from 'react';
import PropTypes from 'prop-types';
import Input from '@material-ui/core/Input';
import { canBePhoneNumber } from '../../../utils/helpers';

const defaultValue = "+48";

const PhoneInput = props => {
    const { value, onChange, className, name } = props;

    const handleChange = (e) => {
        if (canBePhoneNumber(e.target.value))
            onChange && onChange(e.target.value);
        else if(e.target.value === "")
            onChange && onChange("+48");
    };

    return (
        <React.Fragment>
            <Input
                className={className}
                name={name}
                value={value ? value : defaultValue}
                onChange={handleChange}
            />
        </React.Fragment>
    );
};

PhoneInput.propTypes = {
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    name: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
};

export default PhoneInput;
